// extracted by mini-css-extract-plugin
export default {"plan_banner":"plan_banner___DECkF"};